const DESIGN_SYSTEM_STATIC_COLORS = {
  ERROR: '#da3418',
  ERROR_DARK: '#863c32',
  CAUTION: '#e2a73d',
  SUCCESS: '#4aa81f',
  SUCCESS_DARK: '#3d6d27',
  SUCCESS_LIGHT: '#eef5eb',
  LINK: '#4277a4',
  MIDNIGHT_100: '#292933',
  MIDNIGHT_90: '#3e3e47',
  MIDNIGHT_80: '#54545c',
  MIDNIGHT_70: '#696970',
  MIDNIGHT_60: '#78787f',
  MIDNIGHT_50: '#949499',
  MIDNIGHT_40: '#a9a9ad',
  MIDNIGHT_30: '#bebec1',
  MIDNIGHT_20: '#d4d4d6',
  MIDNIGHT_10: '#e9e9ea',
  MIDNIGHT_5: '#f4f4f5',
  MIDNIGHT_3: '#f8f8f9',
  WHITE: '#ffffff',
};

/**
 * DEPRECATED Legacy Brand Colors
 * Please DO NOT USE, we will work to remove these overtime
 *
 * Refer to ui/_variables.scss for updated static color variables
 *
 */
const colors = {
  GREEN: '#8ad476',
  BLUE: '#4a90e2',
  YELLOW_LIGHTER: '#f9e2a7',
  YELLOW: '#f9cf36',
  YELLOW_DARK: '#f6bf35',
  RED_DARK: '#ce463c',
  INDIGO: '#5c62a4',
  GRAY_LIGHT: '#dedddd',
  GRAY_LIGHTER: '#ebeaea',
  GRAY_LIGHTEST: '#f7f7f7',
  GRAY_DARK: '#a3a2a1',
  NIGHT: '#2d2d2d',
};

export default {
  ...colors,
  ...DESIGN_SYSTEM_STATIC_COLORS,
};
